// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3ZK-D","header":"ClearentDisclaimer_header__19ih8","inner":"ClearentDisclaimer_inner__8M73g"};